import { useState } from "react";
import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import { useAppSelector } from "../utils/hooks";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AppConfirmDialog from "./AppConfirmDialog";
import TextInputDialog from "./TextInputDialog";
import ShareGroupDialog from "./ShareGroupDialog";



type BeaconGroupProps = {
    open: boolean;
    anchorElement: HTMLButtonElement | null;
    setIsOpen: (open: boolean) => void;
    editFunction: () => void;
    archiveFunction: (event: any) => void;
    deleteFunction: (event: any) => void;
    duplicateFunction: (groupId: string | undefined, name: string | null) => void;
    shareFunction: (groupId: string | undefined, email: string | null, accessLevel: string, callBack: (code?: string) => void ) => void;
};

const BeaconGroupMenu = ({open, anchorElement, setIsOpen, editFunction, archiveFunction, deleteFunction, duplicateFunction, shareFunction}: BeaconGroupProps) => {

    const businessGroupState = useAppSelector((state) => state.businessGroup);
    const group = businessGroupState.currentBusinessGroup;

    const [openDuplicateGroup, setOpenDuplicateGroup] = useState<boolean>(false);
    const [openArchiveGroupMessage, setOpenArchiveGroupMessage] = useState<boolean>(false);
    const [openDeleteGroupMessage, setOpenDeleteGroupMessage] = useState<boolean>(false);
    const [openShareGroupMessage, setOpenShareGroupMessage] = useState<boolean>(false);

    const [shareCode, setShareCode] = useState<string>("");

    const checkShareAccess = () => {
      if (group?.is_shared) {
        if (group.access_level === "admin") {
          return true;
        } else {
          return false;
        }
      }
      // If not shared, and owned by original user, allow 
      return true;
    };

    return ( 
    <>
    <Popper
      open={open}
      anchorEl={anchorElement}
      role={undefined}
      placement="bottom-start"
      transition
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === 'bottom-start' ? 'left top' : 'left bottom',
          }}
        >
          <Paper sx={{ backgroundColor: "white", zIndex: 9999 }}>
            <ClickAwayListener onClickAway={() => setIsOpen(false)}>
              <MenuList
                autoFocusItem={open}
                id="composition-menu"
                aria-labelledby="composition-button"
              >
                <MenuItem onClick={() => {
                  setIsOpen(false);
                  editFunction();
                }}
                >
                <EditOutlinedIcon sx={{
                    marginRight: 3
                }}/>
                  Edit
                </MenuItem>
                {checkShareAccess() && (
                  <MenuItem onClick={() => {
                    setIsOpen(false);
                    setOpenShareGroupMessage(true);
                  }}>
                  <GroupsOutlinedIcon sx={{
                      marginRight: 3
                  }}/>
                    Share
                  </MenuItem>
                )}
                <MenuItem onClick={() => {
                  setIsOpen(false);
                  setOpenDuplicateGroup(true);
                }}>
                <ContentCopyIcon sx={{
                    marginRight: 3
                }}/>
                  Duplicate
                </MenuItem>
                  <MenuItem onClick={() => {
                  setIsOpen(false);
                  setOpenArchiveGroupMessage(true);
                }}>
                <ArchiveOutlinedIcon sx={{
                    marginRight: 3
                }}/>
                  {businessGroupState.currentBusinessGroup?.archived ? 
                    "Unarchive" : "Archive"
                  }
                </MenuItem>
                {checkShareAccess() && (
                <MenuItem onClick={() => {
                  setIsOpen(false);
                  setOpenDeleteGroupMessage(true);
                }}>
                <DeleteOutlineIcon sx={{
                    marginRight: 3
                }}/>
                  Delete
                </MenuItem>
                )}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
    <AppConfirmDialog
        open={openDeleteGroupMessage}
        onConfirm={() => {
            deleteFunction(businessGroupState.currentBusinessGroup?.id); 
            setOpenDeleteGroupMessage(false);
        }}
        onDeny={() => {
            setOpenDeleteGroupMessage(false);
        }}
        title="Are you sure you want to delete the Experience: "
        confirmButtonTitle="Delete"
        denyButtonTitle="Cancel"
        content={businessGroupState.currentBusinessGroup?.name + "?"}
        dialogTitle="Delete Experience"
    />
    <AppConfirmDialog
        open={openArchiveGroupMessage}
        onConfirm={() => {
            archiveFunction(businessGroupState.currentBusinessGroup?.id); 
            setOpenArchiveGroupMessage(false);
        }}
        onDeny={() => {
            setOpenArchiveGroupMessage(false);
        }}
        title="Are you sure you want to archive the Experience: "
        confirmButtonTitle="Archive"
        denyButtonTitle="Cancel"
        content={businessGroupState.currentBusinessGroup?.name + "?"}
        dialogTitle="Archive Experience"
    />
    <TextInputDialog
        open={openDuplicateGroup}
        onClose={(name) => {
            setOpenDuplicateGroup(false);
            duplicateFunction(businessGroupState.currentBusinessGroup?.id, name);
        }}
        title="Duplicate Experience"
        inputLabel="Duplicated Experience Name"
        enterText="Save"
        defaultValue={businessGroupState.currentBusinessGroup?.name}
    />
    <ShareGroupDialog 
        open={openShareGroupMessage}
        onConfirm={(email, accessLevel) => {
            shareFunction(businessGroupState.currentBusinessGroup?.id, email, accessLevel, (code) => {
              if(code) setShareCode(code);
            }); 
        }}
        onDeny={() => {
            setOpenShareGroupMessage(false);
            setShareCode("");
        }}
        title="Share"
        content="Enter the email address you would like to share to:"
        dialogTitle="Share"
        confirmButtonTitle="Create"
        denyButtonTitle="Cancel"
        shareCode={shareCode}
    />
    </>
    );
};

export default BeaconGroupMenu;
